import {
  IApplicationComponentLayoutModel,
  IApplicationComponentModel,
  IApplicationComponentPropertyModel,
  PropertyType,
  RecordStatus,
} from "@xala/common-services";
import { ComponentLayoutPropertyModel } from "./ComponentLayoutPropertyModel";
import { ComponentPropertyModel } from "./ComponentPropertyModel";
import { LayoutOptionsModel } from "./LayoutOptionsModel";

export class EpgComponentPropertyModel extends ComponentPropertyModel {
  SourceId?: number;

  SourceName?: string;

  Layout?: ComponentLayoutPropertyModel;

  constructor(component?: IApplicationComponentModel) {
    super();

    if (component) {
      this.init(component);
    }
  }

  hasBackgroundUrl(): boolean {
    return false;
  }
  hasIconUrl(): boolean {
    return false;
  }
  hasImageUrl(): boolean {
    return false;
  }

  public getLayoutProperty(
    component: IApplicationComponentModel,
    layoutOptions: LayoutOptionsModel
  ): ComponentLayoutPropertyModel {
    if (!component.Layouts) {
      component.Layouts = [];
    }

    let componentLayout = component.Layouts.find(
      (row: IApplicationComponentLayoutModel) =>
        row.PlatformCode === layoutOptions.Platform
    );

    let height = 1;

    if (!componentLayout) {
      componentLayout = {
        RecordStatus: RecordStatus.Inserted,
        ApplicationComponentId: component.Id,
        PlatformCode: layoutOptions.Platform,
        PositionX: 0,
        PositionY: layoutOptions.CurrentPositionY,
        Width: 12,
        Height: height,
      };

      component.Layouts.push(componentLayout);
    }

    componentLayout.Width = 12;

    if (componentLayout.Height !== height) {
      componentLayout.Height = height;
    }

    return {
      PositionX: componentLayout.PositionX,
      PositionY: componentLayout.PositionY,
      Width: componentLayout.Width,
      Height: componentLayout.Height,
      IsResizable: false,
      IsDraggable: true,
    };
  }

  setProperties(component: IApplicationComponentModel): void {
    let sourceIdProperty = component.Properties?.find(
      (row: IApplicationComponentPropertyModel) => row.Name === "SourceId"
    );

    if (sourceIdProperty && sourceIdProperty.Value) {
      this.SourceId = sourceIdProperty.Value.IntegerValue;
    }

    let sourceNameProperty = component.Properties?.find(
      (row: IApplicationComponentPropertyModel) => row.Name === "SourceName"
    );

    if (sourceNameProperty && sourceNameProperty.Value) {
      this.SourceName = sourceNameProperty.Value.StringValue;
    }
  }

  setProperty(property: IApplicationComponentPropertyModel) {
    switch (property.Name) {
      case "SourceId":
        property.PropertyType = PropertyType.Integer;
        property.IsEnumerable = false;
        break;
      case "SourceName":
        property.PropertyType = PropertyType.String;
        property.IsEnumerable = false;
        break;
    }
  }

  setPropertyValue(property: IApplicationComponentPropertyModel) {
    switch (property.Name) {
      case "SourceId":
        if (property.Value) {
          property.Value.IntegerValue = this.SourceId;
        }
        break;
      case "SourceName":
        if (property.Value) {
          property.Value.StringValue = this.SourceName;
        }
        break;
    }
  }
}
